import { render, staticRenderFns } from "./SetDepartment.vue?vue&type=template&id=eab7198a"
import script from "./SetDepartment.vue?vue&type=script&lang=js"
export * from "./SetDepartment.vue?vue&type=script&lang=js"
import style0 from "./SetDepartment.vue?vue&type=style&index=0&id=eab7198a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports